import { useRef, useState } from 'react'
import { Card, Button, Col } from 'react-bootstrap'
import { useReactToPrint } from 'react-to-print'
import { Collapse } from '@material-ui/core'
import { IconButton, Icon, Notification } from 'rsuite'
import moment from 'moment'
import 'moment/locale/pt-br'

import Alert from '@material-ui/lab/Alert'
import CloseIcon from '@material-ui/icons/Close'
import api from '../../services/api'
import history from '../../history'
import FixedColumnTable from './fixedTable'
import FixedColumnTableCheck from './fixedTableNotCheck'

import './styles.css'

const CorpobackupSeman = ({ info, not }) => {
  moment.locale('pt')
  const componentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const [open, setOpen] = useState(true)
  const [contend, setContend] = useState(false)

  async function handleCheckAll() {
    await api
      .post('/scripts/check/all', {
        empresa: info.name,
      })
      .then(() => {
        return Notification['success']({
          placement: 'bottomEnd',
          title: 'Sucesso!',
          description: `Todos os backups da ${info.name} foram marcados como checados com sucesso`,
        })
      })
  }
  return (
    <Col>
      <Card className="Card" ref={componentRef}>
        <Card.Header
          onClick={() => {
            setContend(!contend)
          }}
        >
          <div className="HeaderDiv">
            {info.name}

            {info && contend && (
              <IconButton
                icon={<Icon icon="print" />}
                onClick={() => {
                  handlePrint()
                }}
              >
                Imprimir
              </IconButton>
            )}
          </div>
        </Card.Header>

        {info && contend && !not && (
          <div>
            <Collapse in={open} unmountOnExit>
              <Alert
                icon={false}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpen(false)
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                Clique
                <Button
                  type="submit"
                  variant="link"
                  size="sm"
                  onClick={handleCheckAll}
                >
                  aqui
                </Button>
                para marcar todos os backups da {info.name} como conferidos
              </Alert>
            </Collapse>
            <Card.Body>
              <div>
                <FixedColumnTable day={0} name={info.name} />
                <FixedColumnTable day={1} name={info.name} />
                <FixedColumnTable day={2} name={info.name} />
                <FixedColumnTable day={3} name={info.name} />
                <FixedColumnTable day={4} name={info.name} />
                <FixedColumnTable day={5} name={info.name} />
              </div>
            </Card.Body>
          </div>
        )}

        {info && contend && not && (
          <div>
            <Collapse in={open} unmountOnExit>
              <Alert
                icon={false}
                action={
                  <Icon
                    icon="close"
                    onClick={() => {
                      setOpen(false)
                    }}
                  ></Icon>
                }
              >
                Clique
                <Button
                  type="submit"
                  variant="link"
                  size="sm"
                  onClick={handleCheckAll}
                >
                  aqui
                </Button>
                para marcar todos os backups da {info.name} como conferidos
              </Alert>
            </Collapse>
            <Card.Body>
              <div>
                <FixedColumnTableCheck day={0} name={info.name} />
                <FixedColumnTableCheck day={1} name={info.name} />
                <FixedColumnTableCheck day={2} name={info.name} />
                <FixedColumnTableCheck day={3} name={info.name} />
                <FixedColumnTableCheck day={4} name={info.name} />
                <FixedColumnTableCheck day={5} name={info.name} />
              </div>
            </Card.Body>
          </div>
        )}
      </Card>
    </Col>
  )
}
export default CorpobackupSeman
